import React from 'react';
import { ForgeIcon, ForgeTooltip } from '@tylertech/forge-react';

const ErrorIconColumn = () => {
  return {
    colId: 'error_tooltip',
    context: 'error',
    headerName: '',
    width: 25,
    pinned: 'left',
    lockPosition: 'left',
    filter: false,
    resizable: false,
    editable: false,
    sortable: false,
    suppressColumnsToolPanel: true,
    cellRenderer: (params) => {
      return params.data.Error || params.data.numberOfItemsError  ? (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            marginLeft: '-10px',
            paddingTop: '8px',
            justifyContent: 'center',
          }}
        >
          <ForgeIcon
            id={`${params.node.rowIndex}_error`}
            name={'error'}
            external
            style={{ color: 'var(--forge-theme-on-error-container-low)' }}
          />
          <ForgeTooltip
            anchor={`${params.node.rowIndex}_error`}
            position={'bottom'}
          >
            {' '}
            {params.data.Error || params.data.numberOfItemsError}
          </ForgeTooltip>
        </div>
      ) : null;
    },
  };
};

export default ErrorIconColumn;
